import { meetgeekApiRoot } from './explorerService';

function scopeQs({ companyId, recruiterId }) {
  const params = new URLSearchParams();
  if (companyId) params.set('company_id', String(companyId));
  if (recruiterId) params.set('recruiter_id', String(recruiterId));
  return params.toString();
}

/** Public shared report (share-panel token). */
export async function getSharedMeetingReport(token) {
  const res = await fetch(
    `${meetgeekApiRoot()}/share/public/report?token=${encodeURIComponent(token)}`,
  );
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(detail || 'Failed to load shared report');
  }
  return res.json();
}

export async function getSharedMeetingText(token, kind) {
  const res = await fetch(
    `${meetgeekApiRoot()}/share/public/text/${encodeURIComponent(kind)}?token=${encodeURIComponent(token)}`,
  );
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(detail || `Failed to load ${kind}`);
  }
  return res.text();
}

export function sharedMeetingMediaUrl(token, kind) {
  return `${meetgeekApiRoot()}/share/public/media/${encodeURIComponent(kind)}?token=${encodeURIComponent(token)}`;
}

export async function getMeetingShare(roomName, { companyId, recruiterId }) {
  const qs = scopeQs({ companyId, recruiterId });
  const res = await fetch(
    `${meetgeekApiRoot()}/share/meetings/${encodeURIComponent(roomName)}?${qs}`,
  );
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(detail || 'Failed to load share settings');
  }
  return res.json();
}

export async function shareMeetingReport(
  roomName,
  { companyId, recruiterId, accessType, guests = [], emails = [] },
) {
  const qs = scopeQs({ companyId, recruiterId });
  const res = await fetch(
    `${meetgeekApiRoot()}/share/meetings/${encodeURIComponent(roomName)}?${qs}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        company_id: companyId,
        recruiter_id: recruiterId,
        accessType,
        guests,
        emails,
      }),
    },
  );
  if (!res.ok) {
    let message = 'Failed to share meeting report';
    try {
      const data = await res.json();
      message = data?.error || data?.message || message;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  return res.json();
}

/** Revoke a restricted email link (removes from shared_with). */
export async function removeMeetingShareAccess(
  roomName,
  { companyId, recruiterId, email },
) {
  const qs = scopeQs({ companyId, recruiterId });
  const res = await fetch(
    `${meetgeekApiRoot()}/share/meetings/${encodeURIComponent(roomName)}/remove-access?${qs}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        company_id: companyId,
        recruiter_id: recruiterId,
        email,
      }),
    },
  );
  if (!res.ok) {
    let message = 'Failed to remove access';
    try {
      const data = await res.json();
      message = data?.error || data?.message || message;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  return res.json();
}
